





import { Component, Prop, Vue } from 'vue-property-decorator';
import EmblaCarousel from 'embla-carousel';
import { addPrevNextBtnsClickHandlers } from '@/commons/emblaSlider';
import algolia from '@/commons/algolia';
import { updateURLParameter } from '@/commons/utils';
import { i18n } from '@/i18n';

// see https://www.embla-carousel.com/guides/slide-container/
EmblaCarousel.globalOptions = { slidesToScroll: 1, align: 'start' };

function ucfirst(val: any) {
  return String(val).charAt(0).toUpperCase() + String(val).slice(1);
}

function renderItem(item: any, algoliaConfig: any) {
  let priceStr;
  const finalPrice = item.tdy_special_price;
  const regularPrice = item.tdy_original_price;
  const origPriceFormatted = Vue.filter('currency')(regularPrice);
  let url = item.url;
  if (algoliaConfig.analyticsEnabled && item.__queryID){
    url = updateURLParameter(url, {queryID: item.__queryID, objectID: item.objectID, indexName: algoliaConfig.indexName});
  }
  if (finalPrice) {
    const specialPriceFormatted = Vue.filter('currency')(finalPrice);
    priceStr = `<span class="original discounted">${origPriceFormatted}</span><span class="final">${specialPriceFormatted}</span>`;
  } else {
    priceStr = `<span class="original">${origPriceFormatted}</span>`;
  }
  return `<div class="embla__slide">
  <a class="recommend-item product-url" href="${url}" data-objectid=${item.objectID} data-position=${item.position}>
      <div class="product-img-wrapper">
        <img class="product-img" src="${item.tdy_images.main}" alt="${item.name}"/>
      </div>
      <p class="product-name">${item.name}</p>
      <div class="price">${priceStr}</div>
  </a>
</div>`;
}

@Component
export default class AlgoliaRecommend extends Vue {
  @Prop() private itemIds: any;
  @Prop() private recommendModel: any;
  @Prop() private recommendConfig: any;

  private mounted() {
    algolia().then((algoliaTransport: any) => {
      const { searchClient, algoliaConfig } = algoliaTransport;
      const title = i18n.t(this.recommendConfig.title);
      const algoliaSearchInstance = instantsearch({searchClient, indexName: algoliaConfig.indexName});
      const elId = '#recommend-container-' + this.recommendModel;
      const connector = instantsearch.connectors['connect'+ ucfirst(this.recommendModel)];
      const widgetFactory = connector((renderOptions: any) => {
        const { items } = renderOptions;
        if (items && items.length > 0) {
          const el = document.querySelector(elId) as HTMLElement;
          el.innerHTML =
              `<h2 class="auc-Recommend-title">${title}</h2>
                <div class="embla">
                  <div class="embla__viewport">
                    <div class="embla__container">
                      ${items.map((item: any) => renderItem(item, algoliaConfig)).join('')}
                    </div>
                </div>
                <div class="btns">
                  <button class="embla__button embla__button--prev" type="button">
                    <svg class="embla__button__svg" viewBox="0 0 532 532">
                      <path
                        fill="currentColor"
                        d="M355.66 11.354c13.793-13.805 36.208-13.805 50.001 0 13.785 13.804 13.785 36.238 0 50.034L201.22 266l204.442 204.61c13.785 13.805 13.785 36.239 0 50.044-13.793 13.796-36.208 13.796-50.002 0a5994246.277 5994246.277 0 0 0-229.332-229.454 35.065 35.065 0 0 1-10.326-25.126c0-9.2 3.393-18.26 10.326-25.2C172.192 194.973 332.731 34.31 355.66 11.354Z"
                      ></path>
                    </svg>
                  </button>
                  <button class="embla__button embla__button--next" type="button">
                    <svg class="embla__button__svg" viewBox="0 0 532 532">
                      <path
                        fill="currentColor"
                        d="M176.34 520.646c-13.793 13.805-36.208 13.805-50.001 0-13.785-13.804-13.785-36.238 0-50.034L330.78 266 126.34 61.391c-13.785-13.805-13.785-36.239 0-50.044 13.793-13.796 36.208-13.796 50.002 0 22.928 22.947 206.395 206.507 229.332 229.454a35.065 35.065 0 0 1 10.326 25.126c0 9.2-3.393 18.26-10.326 25.2-45.865 45.901-206.404 206.564-229.332 229.52Z"
                      ></path>
                    </svg>
                  </button>
                </div>
              </div>`;
          const viewportNode = el.querySelector('.embla .embla__viewport') as HTMLElement;
          const prevButtonNode = el.querySelector('.btns .embla__button--prev') as HTMLElement;
          const nextButtonNode = el.querySelector('.btns .embla__button--next') as HTMLElement;
          const emblaApi = EmblaCarousel(viewportNode);
          const removePrevNextBtnsClickHandlers = addPrevNextBtnsClickHandlers(emblaApi, prevButtonNode, nextButtonNode);
          emblaApi.on('destroy', removePrevNextBtnsClickHandlers)
        }
      });

      const totSlides = this.recommendConfig.slides ? this.recommendConfig.slides : 6;
      algoliaSearchInstance.addWidgets([widgetFactory({objectIDs: this.itemIds, limit: totSlides})]);
      this.$nextTick(() => {
          algoliaSearchInstance.start();
      });
    });
  }
}
